import type { FilterDefinition, FilterHandler } from '../engine/types';
import { FilterId, FilterType, type GroupFilter } from '../types/filters';

// Funding Info is a group filter - clicking it shows child filters in a submenu
export const fundingInfoDefinition: FilterDefinition<GroupFilter> = {
  id: FilterId.FUNDING_INFO,
  name: 'Funding Info',
  type: FilterType.GROUP,
  isVisible: true,
  children: [
    FilterId.FUNDING_STAGE,
    FilterId.VALUATION,
    FilterId.LAST_FUNDING_AMOUNT,
    FilterId.TOTAL_FUNDING_AMOUNT,
    FilterId.LAST_FUNDING_YEAR,
  ],
};

export const fundingInfoHandler: FilterHandler<GroupFilter> = {
  isActive(_currentFilterState: GroupFilter) {
    // Group filters are never active themselves
    return false;
  },
  isDefault(_currentFilterState: GroupFilter) {
    // Group filters are always in default state
    return true;
  },
  getEffectiveFilter(currentFilterState: GroupFilter) {
    return { ...currentFilterState };
  },
};
